import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { invitationAPI, authAPI } from '../services/api';
import './ClubFund.css';

function InviteAccept() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accepting, setAccepting] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const loadInvite = async () => {
      try {
        const data = await invitationAPI.getDetails(token);
        if (data.success) {
          setInvite(data.invitation);
        } else {
          setError(data.error || 'Invalid invitation');
        }
      } catch (err) {
        setError(err.response?.data?.error || 'Invitation not found or expired');
      }
      setLoading(false);
    };
    loadInvite();
  }, [token]);

  const handleAccept = async () => {
    if (!authAPI.isAuthenticated()) {
      navigate(`/register?invite=${token}`);
      return;
    }

    setAccepting(true);
    try {
      const data = await invitationAPI.accept(token);
      if (data.success) {
        setAccepted(true);
        if (data.needsBookieLink) {
          setTimeout(() => navigate(`/register/link?clubId=${data.clubId}&action=existing`), 2000);
        } else {
          setTimeout(() => navigate(`/dashboard/${data.clubId}`), 2000);
        }
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to join');
    }
    setAccepting(false);
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a' }}>
        <p style={{ color: '#999' }}>Loading invitation...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a' }}>
        <div style={{ textAlign: 'center', maxWidth: 400 }}>
          <h2 style={{ color: '#ef4444', marginBottom: '1rem' }}>Invitation Error</h2>
          <p style={{ color: '#999', marginBottom: '1.5rem' }}>{error}</p>
          <button onClick={() => navigate('/login')} style={{ background: '#fbbf24', color: '#000', border: 'none', borderRadius: '8px', padding: '0.75rem 2rem', fontWeight: 600, cursor: 'pointer' }}>
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (accepted) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#10003;</div>
          <h2 style={{ color: '#10b981', marginBottom: '0.5rem' }}>You're In!</h2>
          <p style={{ color: '#999' }}>Redirecting to your club...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a' }}>
      <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '2rem', maxWidth: 400, width: '90%', textAlign: 'center' }}>
        <h2 style={{ color: '#fff', marginBottom: '0.5rem' }}>You've Been Invited!</h2>
        <p style={{ color: '#fbbf24', fontSize: '1.1rem', fontWeight: 600, marginBottom: '0.5rem' }}>{invite.clubName}</p>
        {invite.message && invite.message !== 'Shareable invite link' && (
          <p style={{ color: '#999', fontSize: '0.9rem', fontStyle: 'italic', marginBottom: '1.5rem' }}>"{invite.message}"</p>
        )}
        <button onClick={handleAccept} disabled={accepting} style={{ width: '100%', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', padding: '0.85rem', fontWeight: 600, fontSize: '1rem', cursor: 'pointer', marginBottom: '0.75rem' }}>
          {accepting ? 'Joining...' : authAPI.isAuthenticated() ? 'Join Club' : 'Sign Up & Join'}
        </button>
        {!authAPI.isAuthenticated() && (
          <p style={{ color: '#666', fontSize: '0.8rem' }}>
            Already have an account? <a href="/login" style={{ color: '#fbbf24' }}>Log in first</a>
          </p>
        )}
      </div>
    </div>
  );
}

export default InviteAccept;
